import { GetClubsByZoneResponse } from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getZipCodeLookup = async (
  zipCode?: string
): Promise<GetClubsByZoneResponse> => {
  if (!zipCode) {
    return Promise.reject(new Error('Missing zip code'));
  }

  const { data } = await axios.get<GetClubsByZoneResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/clubs/zones/${zipCode}`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
        'x-api-key': import.meta.env.VITE_X_API_KEY ?? '',
      },
    }
  );

  return data;
};

export const useZipCodeQuery = (zipCode?: string) =>
  useQuery({
    queryKey: ['zipCode', zipCode],
    queryFn: () => getZipCodeLookup(zipCode),
    staleTime: 0,
    gcTime: 0,
    retry: 0,
    enabled: !!zipCode,
  });
